module.exports = __webpack_public_path__ + "img/marina_kaye.d7f0fe3c.jpg";